import React from "react";
import SearchIcon from "./img/searchIcon.svg";
import CloseIcon from "../Snackbar/img/close.svg";
import "./SearchInput.css";

const SearchInput = (props) => {
  const {
    containerWidth,
    text,
    containerHeight,
    value,
    onChangeText,
    ariaLabel,
    showClearButton = true,
  } = props;

  const resolvedAriaLabel = ariaLabel || text || "Search";

  const handleClear = () => {
    onChangeText({ target: { value: "" } });
  };

  const hasValue = Boolean(value);

  return (
    <div className="search-input-container">
      <div className="search-input" style={{ width: containerWidth }}>
        {!hasValue && (
          <img
            src={SearchIcon}
            className="iconn-search"
            alt=""
            aria-hidden="true"
          />
        )}
        <input
          type="text"
          placeholder={text}
          className={`inputSearch${hasValue ? " inputSearch--has-value" : ""}`}
          style={{ height: containerHeight, backgroundColor: "#FFFFFF" }}
          value={value}
          onChange={(e) => onChangeText(e)}
          aria-label={resolvedAriaLabel}
          role="searchbox"
        />
        {showClearButton && hasValue && (
          <button
            type="button"
            className="search-input-clear"
            onClick={handleClear}
            aria-label="Clear search"
          >
            <img src={CloseIcon} alt="" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
